import { useMediaQuery } from '@mui/material'
import { ReactComponent as CDTProcessingLogo } from 'common/assets/CDT_Processing_Logo_Small.svg'
import { ReactComponent as CDTUsersLogo } from 'common/assets/CDT_Users_Logo_Small.svg'
import { ReactComponent as CDTVendorsLogo } from 'common/assets/CDT_Vendor_Logo_Small.svg'
import { ReactComponent as CDTReportingLogo } from 'common/assets/CDT_reporting_Logo_1.svg'
import DrawerNavigation from 'common/navigation/layout/drawer'
import HeaderNavigation from 'common/navigation/layout/header'
import theme from 'common/utils/theme'
import { DrawerSize, UserApps, type HeaderLink, Role } from 'common/utils/types'
import React, { type ReactElement, type ReactNode } from 'react'
import { Outlet, useHref } from 'react-router-dom'

import styles from './Layout.module.scss'

interface LayoutProps {
  logo: ReactNode
  links: HeaderLink[]
  DrawerShrunkContent?: ReactElement
  DrawerWideContent?: ReactElement
  resetStateExceptCategories?: () => { type: string }
  customNavItemClickAction?: () => unknown
}

const dropdownItems = [
  {
    id: 1,
    logo: <CDTProcessingLogo />,
    roles: [Role.admin, Role.consultant],
    route: UserApps.Processing,
  },
  {
    id: 2,
    logo: <CDTReportingLogo width={180} height={32} />,
    roles: [Role.admin, Role.consultant],
    route: UserApps.Reporting,
  },
  {
    id: 3,
    logo: <CDTVendorsLogo />,
    roles: [Role.admin, Role.consultant, Role.vendor],
    route: UserApps.Vendors,
  },
  {
    id: 4,
    logo: <CDTUsersLogo />,
    roles: [Role.admin],
    route: UserApps.Users,
  },
]

const DRAWER_APPS = [UserApps.Reporting]

const Layout: React.FC<LayoutProps> = ({
  logo,
  links,
  DrawerShrunkContent,
  DrawerWideContent,
  resetStateExceptCategories,
  customNavItemClickAction,
}): ReactElement => {
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'))
  const activeAppRoute: UserApps = useHref('/') as UserApps

  return (
    <div className={styles.mainContainer}>
      <HeaderNavigation
        logo={logo}
        links={links}
        dropdownItems={dropdownItems}
        resetStateExceptCategories={resetStateExceptCategories}
        customClickAction={customNavItemClickAction}
      />
      {DRAWER_APPS.includes(activeAppRoute) && DrawerShrunkContent && DrawerWideContent && (
        <DrawerNavigation DrawerShrunkContent={DrawerShrunkContent} DrawerWideContent={DrawerWideContent} />
      )}
      <div
        className={styles.contentContainer}
        style={{
          paddingLeft: DRAWER_APPS.includes(activeAppRoute)
            ? largeScreen
              ? DrawerSize.Large
              : DrawerSize.Shrunk
            : 0,
          paddingTop: DRAWER_APPS.includes(activeAppRoute) ? '20px' : '73px',
          paddingRight: 0,
        }}
      >
        <Outlet />
      </div>
    </div>
  )
}

export default Layout
